// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-layout-container {
    width: 100%;
    margin: 0 auto;
    background-color: #f9f9f9;
    min-height: 100vh;
    position: relative;
    box-sizing: border-box;
}

.admin-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #222;
    color: white;
    padding: 30px 40px;
    position: relative;
    z-index: 100;
}

.logo-container {
    display: flex;
    align-items: center;
}

.logo {
    height: 58px;
}

.admin-title {
    color: #e84118;
    margin-left: 10px;
    font-size: 18px;
    font-weight: bold;
}

.header-nav span {
    margin-left: 30px;
    cursor: pointer;
}

.header-nav .logout {
    color: #e84118;
}

.main-nav {
    display: flex;
    background-color: #e84118;
    color: white;
    padding: 24px 59px;
    gap: 58px;
    font-size: 16px;
    position: relative;
    z-index: 50;
}

.main-nav a {
    cursor: pointer !important;
    color: white;
    text-decoration: none;
    padding: 8px 12px;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    position: relative;
    z-index: 51;
    pointer-events: auto;
    box-sizing: border-box;
}

.main-nav a:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.main-nav a.active {
    font-weight: bold;
    text-decoration: underline;
    background-color: rgba(255, 255, 255, 0.2);
}

.admin-main-content-wrapper {
    background-color: white;
    position: relative;
    z-index: 1;
}

.mobile-header-actions {
    display: none;
}
.mobile-menu-icon {
    display: none;
}
.mobile-side-menu {
    height: 100vh;
    width: 280px;
    position: fixed;
    top: 0;
    right: 0;
    background-color: #fff;
    z-index: 1000;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.mobile-side-menu.open {
    transform: translateX(0);
}
.mobile-side-menu a {
    color: #333;
    font-size: 16px;
    text-decoration: none;
}
.close-menu-btn {
    background: none;
    border: none;
    color: #333;
    font-size: 24px;
    align-self: flex-start;
    cursor: pointer;
}
.mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .admin-header {
        padding: 20px;
    }

    .main-nav {
        padding: 20px 30px;
        gap: 30px;
        font-size: 15px;
        flex-wrap: wrap;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .admin-header {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 15px;
        padding: 15px;
    }

    .header-nav, .main-nav {
        display: none;
    }
    
    .mobile-header-actions {
        display: block;
    }
    
    .mobile-menu-icon {
        display: block;
        background: none;
        border: none;
        cursor: pointer;
    }

    .mobile-menu-icon svg {
        width: 24px;
        height: 24px;
        fill: white;
    }

    .admin-title, .logo {
        height: 40px;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/AdminLayout.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,MAAM;IACN,QAAQ;IACR,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,sCAAsC;IACtC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;AAChB;;AAEA,+BAA+B;AAC/B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;QACnB,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".admin-layout-container {\n    width: 100%;\n    margin: 0 auto;\n    background-color: #f9f9f9;\n    min-height: 100vh;\n    position: relative;\n    box-sizing: border-box;\n}\n\n.admin-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #222;\n    color: white;\n    padding: 30px 40px;\n    position: relative;\n    z-index: 100;\n}\n\n.logo-container {\n    display: flex;\n    align-items: center;\n}\n\n.logo {\n    height: 58px;\n}\n\n.admin-title {\n    color: #e84118;\n    margin-left: 10px;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.header-nav span {\n    margin-left: 30px;\n    cursor: pointer;\n}\n\n.header-nav .logout {\n    color: #e84118;\n}\n\n.main-nav {\n    display: flex;\n    background-color: #e84118;\n    color: white;\n    padding: 24px 59px;\n    gap: 58px;\n    font-size: 16px;\n    position: relative;\n    z-index: 50;\n}\n\n.main-nav a {\n    cursor: pointer !important;\n    color: white;\n    text-decoration: none;\n    padding: 8px 12px;\n    border-radius: 4px;\n    transition: background-color 0.2s ease;\n    position: relative;\n    z-index: 51;\n    pointer-events: auto;\n    box-sizing: border-box;\n}\n\n.main-nav a:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n.main-nav a.active {\n    font-weight: bold;\n    text-decoration: underline;\n    background-color: rgba(255, 255, 255, 0.2);\n}\n\n.admin-main-content-wrapper {\n    background-color: white;\n    position: relative;\n    z-index: 1;\n}\n\n.mobile-header-actions {\n    display: none;\n}\n.mobile-menu-icon {\n    display: none;\n}\n.mobile-side-menu {\n    height: 100vh;\n    width: 280px;\n    position: fixed;\n    top: 0;\n    right: 0;\n    background-color: #fff;\n    z-index: 1000;\n    transform: translateX(100%);\n    transition: transform 0.3s ease-in-out;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n.mobile-side-menu.open {\n    transform: translateX(0);\n}\n.mobile-side-menu a {\n    color: #333;\n    font-size: 16px;\n    text-decoration: none;\n}\n.close-menu-btn {\n    background: none;\n    border: none;\n    color: #333;\n    font-size: 24px;\n    align-self: flex-start;\n    cursor: pointer;\n}\n.mobile-menu-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .admin-header {\n        padding: 20px;\n    }\n\n    .main-nav {\n        padding: 20px 30px;\n        gap: 30px;\n        font-size: 15px;\n        flex-wrap: wrap;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .admin-header {\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        gap: 15px;\n        padding: 15px;\n    }\n\n    .header-nav, .main-nav {\n        display: none;\n    }\n    \n    .mobile-header-actions {\n        display: block;\n    }\n    \n    .mobile-menu-icon {\n        display: block;\n        background: none;\n        border: none;\n        cursor: pointer;\n    }\n\n    .mobile-menu-icon svg {\n        width: 24px;\n        height: 24px;\n        fill: white;\n    }\n\n    .admin-title, .logo {\n        height: 40px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
